import { Injectable, Inject } from '@angular/core';

declare var jQuery: any;
/*
 * HEY YOU! This is a service for low-level helper methods.  It shouldn't have any
 * other services injected into it.  It shouldn't have any model references.  It
 * exists so that we have a place for commonly used javascript stuffs. 
 */
@Injectable()
export class SyntacticSugarService {
    
    public isObjectUndefined(obj: any): boolean {
        return (obj === null || obj === undefined);
    }
    
    public isStringEmpty(text: string): boolean {
        return (text === null || text === undefined || text.trim().length === 0);
    }
    
    public isStringEmptyOrZero(text: string): boolean {
        const isZero = text === "0";
        return this.isStringEmpty(text) || isZero;
    }
    
    public clone(thing: any): any {
        return JSON.parse(JSON.stringify(thing));
    }
    
    /**
     * Gets a number value of the "value" string. An empty string returns "0".
     */
    public getNumber(value: string): number {
        return Number(value);
    }
    
    public getNumberWithZeroDefault(value: number): number {
        if(value === null || value === undefined) {
            return 0;
        } else {
            return value;
        }
    }
    
    /**
     * Given two numbers as strings, return true if the first is greater, otherwise return false.
     */
    public firstNumberGreaterThanSecond(first: string, second: string): boolean {
        const firstNum = this.getNumber(first);
        const secondNum = this.getNumber(second);
        return firstNum > secondNum;
    }
    
    /**
     * Get the activeElement. If it has an id and is an input, trigger blur on it.
     * For hack use only.
     */
    public blurActiveInput(): void {
        const activeElt = document.activeElement.id;
        if(!this.isStringEmpty(activeElt)) {
            if(jQuery("#" + activeElt).is("input")) {
                jQuery("#" + activeElt).blur();
            }
        }
    }
    
    public padStart(val: string, size: number, char: string) {
        if(this.isStringEmpty(val)) {
            
        } else {
            while (val.length < size) {
                val = char + val;
            }
        }
        return val;
    }
    
    /**
     * This function strips the HTML from the string passed in
     * @param string
     * @return string with HTML stripped from it
     */
    public stripHtml(text : string) : string {
        let stripped = text.replace(/<[^>]+>/g, '');
        return stripped;
    }
}